import * as React from 'react';
import cx from 'classnames';
import px from 'prop-types';
import { useSelector } from 'react-redux';
import { LinkItem } from 'Common/components/ui';
import { Translation } from 'Common/components/localization';
import { LinkItem as LinkItemType } from 'Common/types';
import { product } from '~features';

export default function DetailsLinks({ className, retailSearch, onAddItemToCompare = null }) {
    const currentItemStatus = useSelector(product.selectors.getCurrentItemStatus);

    const onClickCompare = React.useCallback(
        (sku) => (event) => {
            event.preventDefault();
            onAddItemToCompare(sku);
        },
        [onAddItemToCompare]
    );

    return (
        <div className={cx('DetailsLinks', 'd-flex', className)}>
            {retailSearch ? (
                <LinkItem className="paragraph-3" link={retailSearch}>
                    <i className="fa fa-search me-2" aria-hidden="true"></i>
                    <strong>
                        <Translation id="Commerce.Product.Link.RetailSearch.Label" />
                    </strong>
                </LinkItem>
            ) : null}
            {onAddItemToCompare ? (
                <a className="ProductCompareLabel paragraph-3" onClick={onClickCompare(currentItemStatus.code)}>
                    <i className="fa fa-chart-bar"></i>{' '}
                    <strong>
                        <Translation id="Commerce.Product.Compare" />
                    </strong>
                </a>
            ) : null}
        </div>
    );
}

DetailsLinks.propTypes = {
    className: px.string,
    retailSearch: LinkItemType,
    onAddItemToCompare: px.func,
};
